import { httpClient } from '@/plugins/axios';
import type { ProfilesView } from './types';
import { defineStore } from 'pinia';

export const useProfileStore = defineStore({
  id: 'profiles',
  state: () => ({
    profileStore: null as ProfilesView[] | null,
    halcStore: null as ProfilesView[] | null,
    aalcStore: null as ProfilesView[] | null,
    apilcStore: null as ProfilesView[] | null,
    wipStore: null as ProfilesView[] | null,
    profileHash: {} as Record<string, ProfilesView>,
  }),
  getters: {},
  actions: {
    async getJson() {
      const response = await httpClient.get(
        `https://assets.contentstack.io/v3/assets/blt1dedeb682e8df2a2/bltade7b84ebb4a4429/FICExtract.json`
      );
      const profiles: ProfilesView[] = response.data;
      this.profileStore = profiles;
      this.profileStore.sort((a, b) => a.LAST_NAME.localeCompare(b.LAST_NAME));
      // filter halc data
      const halcProfile: ProfilesView[] = [];
      const aalcProfile: ProfilesView[] = [];
      const apilcProfile: ProfilesView[] = [];
      const wipProfile: ProfilesView[] = [];
      this.profileStore.forEach((item) => {
        if (item.HALC === 'Y') {
          halcProfile.push(item);
        }
        if (item.AALC === 'Y') {
          aalcProfile.push(item);
        }
        if (item.APIL === 'Y') {
          apilcProfile.push(item);
        }
        if (item.WIP === 'Y') {
          wipProfile.push(item);
        }
      });
      this.halcStore = halcProfile;
      this.aalcStore = aalcProfile;
      this.apilcStore = apilcProfile;
      this.wipStore = wipProfile;
      // this.profileStore = profiles;
      // for loop only return of HALC then set to halcstore
    },
  },
});
